// PartnerBillDetailsComponent.js
import React, { useState, useEffect } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../Loading/component";
import styles from "./PartnerBillDetails.module.css";
import cancel from "../../../../assests/cancel.svg";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import leftArrow from "../../../../assests/leftArrow.svg";
import billsummery from "../../../../assests/billsummery.svg";
import chargeicon from "../../../../assests/chargeicon.svg";

const PartnerBillDetailsComponent = ({
  loading,
  billData,
  payoutBillData,
  onGoBack,
  handleMiscCharge,
  handlePostBill,
  fetchChargeBillSummery,
  chargeSummery,
  allCharges,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [showDeductionDetails, setShowDeductionDetails] = useState(false);
  const [calculatedEndDate, setCalculatedEndDate] = useState("");
  const [calculatedStartDate, setCalculatedStartDate] = useState("");
  const [selectedDayIndex, setSelectedDayIndex] = useState(null);
  const [selectedChargeId, setSelectedChargeId] = useState(null);
  const [activeChargeTab, setActiveChargeTab] = useState("bill");

  useEffect(() => {
    if (billData || payoutBillData) {
      const startDate = calculateStartDate();
      const endDate = calculateEndDate(startDate);
      setCalculatedStartDate(startDate);
      setCalculatedEndDate(endDate);
    }
  }, [billData, payoutBillData]);

  const getChargeDetailsById = (chargeId) => {
    if (!allCharges || !Array.isArray(allCharges)) return null;
    return allCharges.find((charge) => charge.id === chargeId);
  };

  const selectedChargeDetails = getChargeDetailsById(selectedChargeId);

  const getLastDateOfMonth = (dateString) => {
    try {
      if (
        !dateString ||
        dateString === "N/A" ||
        dateString === "null" ||
        dateString === "undefined"
      ) {
        return "N/A";
      }

      let date;
      if (dateString.includes("/")) {
        const [day, month, year] = dateString.split("/").map(Number);
        date = new Date(year, month - 1, day);
      } else if (dateString.includes("-")) {
        date = new Date(dateString);
      } else {
        return "N/A";
      }

      if (isNaN(date.getTime())) return "N/A";

      const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const formattedDay = String(lastDate.getDate()).padStart(2, "0");
      const formattedMonth = String(lastDate.getMonth() + 1).padStart(2, "0");
      const formattedYear = lastDate.getFullYear();

      return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    } catch (error) {
      console.error("Error calculating last date of month:", error);
      return "N/A";
    }
  };

  const formatDateToDDMMYYYY = (dateString) => {
    if (
      !dateString ||
      dateString === "null" ||
      dateString === "undefined" ||
      dateString === "N/A"
    ) {
      return "N/A";
    }

    try {
      let date;
      if (dateString.includes("-")) {
        date = new Date(dateString);
      } else if (dateString.includes("/")) {
        return dateString;
      } else {
        return dateString;
      }

      if (isNaN(date.getTime())) return "N/A";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "N/A";
    }
  };

  const calculateStartDate = () => {
    if (
      billData?.startDate &&
      billData.startDate !== "null" &&
      billData.startDate !== "undefined" &&
      billData.startDate !== "N/A"
    ) {
      return formatDateToDDMMYYYY(billData.startDate);
    }
    return "N/A";
  };

  const calculateEndDate = (startDate) => {
    if (
      billData?.endDate &&
      billData.endDate !== "null" &&
      billData.endDate !== "undefined" &&
      billData.endDate !== "N/A"
    ) {
      return formatDateToDDMMYYYY(billData.endDate);
    }
    if (startDate && startDate !== "N/A") {
      const monthEndDate = getLastDateOfMonth(startDate);
      if (monthEndDate !== "N/A") return monthEndDate;
    }
    return "N/A";
  };

  const getDisplayStartDate = () => {
    if (billData?.startDate) return formatDateToDDMMYYYY(billData.startDate);
    return "N/A";
  };

  const getDisplayEndDate = () => {
    if (
      billData?.endDate &&
      billData.endDate !== "null" &&
      billData.endDate !== "undefined"
    ) {
      return formatDateToDDMMYYYY(billData.endDate);
    }
    const startDate = getDisplayStartDate();
    if (startDate && startDate !== "N/A") {
      const monthEndDate = getLastDateOfMonth(startDate);
      if (monthEndDate !== "N/A") return monthEndDate;
    }
    return "N/A";
  };

  if (loading) return <LoadingSpinner />;
  if (!billData)
    return <div className={styles.pbdNoDataMessage}>No bill data available.</div>;

  // View handlers
  const handleViewBillChargeClick = (charge) => {
    setSelectedCharge(charge);
    setSelectedChargeId(charge.id);
    setActiveChargeTab("bill");
    setOpenDialog(true);
  };

  const handleViewPartnerChargeClick = (charge) => {
    setSelectedCharge(charge);
    setSelectedChargeId(charge.id);
    setActiveChargeTab("partner");
    setOpenDialog(true);
  };

  const totalTransactionalAmount = chargeSummery?.transactionalCharges?.reduce(
    (acc, charge) => acc + charge.amount,
    0,
  );

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    })
      .format(amount)
      .replace("₹", "₹ ");
  };

  const formatChargeTypeLabel = (chargeType) => {
    if (!chargeType) return "N/A";
    if (chargeType === "raas_fee") return "RAAS Fee (%)";
    if (chargeType === "ps_fee") return "PS Fee (%)";
    if (chargeType === "saas_ik") return "SAAS IK";
    if (chargeType === "rental_ik") return "Rental IK";
    if (chargeType === "misc_charge") return "Miscellaneous";
    if (chargeType === "debit") return "Debit";
    return chargeType
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const formatValueType = (valueType) => {
    if (!valueType) return "N/A";
    if (valueType === "amount_percentage") return "Percentage (%)";
    if (valueType === "amount_flat") return "Flat Amount";
    if (valueType === "fixed") return "Fixed";
    if (valueType === "percentage") return "Percentage (%)";
    return valueType.replace(/_/g, " ");
  };

  const totalFixedAmount = chargeSummery?.fixedCharges?.reduce(
    (acc, charge) => acc + charge.amount,
    0,
  );

  const totalDeduction =
    (totalTransactionalAmount || 0) + (totalFixedAmount || 0);

  const selectedDayNetPayable =
    selectedDayIndex !== null
      ? payoutBillData?.payouts?.[selectedDayIndex]?.netPayable || 0
      : 0;

  const netDeduction = totalDeduction + selectedDayNetPayable;
  const isNetPayableNegative = selectedDayNetPayable < 0;

  const handleDeductionClick = (payoutId, totalDeductions, dayIndex) => {
    setSelectedDayIndex(dayIndex);
    if (totalDeductions >= 0) {
      fetchChargeBillSummery(payoutId);
      setShowDeductionDetails(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const formatChargeSummaryDate = () => {
    if (chargeSummery?.date) {
      const date = new Date(chargeSummery.date);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      }
    }
    return "N/A";
  };

  const hasBillId =
    billData?.billId &&
    billData.billId !== "null" &&
    billData.billId !== "undefined" &&
    billData.billId !== "N/A" &&
    billData.billId !== "";

  const billCharges = billData?.charges || [];
  const partnerCharges = Array.isArray(allCharges) ? allCharges : [];

  return (
    <div className={styles.pbdLayout}>
      <Sidebar />
      <div className={styles.pbdContainer}>
        {/* Header Section */}
        <div className={styles.pbdHeaderWrapper}>
          <button className={styles.pbdBackBtn} onClick={onGoBack}>
            <img src={leftArrow} alt="Back" />
          </button>
          <h2 className={styles.pbdTitle}>
            Partner - {billData.name}{" "}
            <span className={styles.pbdTitleId}>
              (Owner ID: {billData.franchiseeId})
            </span>
          </h2>
        </div>

        {/* Bill ID Banner */}
        <div className={styles.pbdBanner}>
          <div className={styles.pbdBannerItem}>
            <span className={styles.pbdBannerLabel}>Bill ID</span>
            <span className={styles.pbdBannerValue}>{billData.billId}</span>
          </div>
          <div className={styles.pbdBannerItem}>
            <span className={styles.pbdBannerLabel}>Total VM</span>
            <span className={styles.pbdBannerValue}>
              {payoutBillData?.vmCount || 0}
            </span>
          </div>
          <div className={styles.pbdBannerRight}>
            <img src={billsummery} alt="Calendar" />
            <span className={styles.pbdBannerLabel}>Start Date:</span>
            <span className={styles.pbdBannerValue}>
              {getDisplayStartDate()}
            </span>
            <span className={styles.pbdBannerLabel}>End Date:</span>
            <span className={styles.pbdBannerValue}>{getDisplayEndDate()}</span>
          </div>
        </div>

        {/* ============================================================
            COMBINED CHARGES SECTION
            ============================================================ */}
        <div className={styles.pbdChargesSection}>
          <div className={styles.pbdChargesHeader}>
            <h4 className={styles.pbdChargesTitle}>
              <span className={styles.pbdIcon}>⚡</span> Charges
            </h4>
            {billData.status !== "CLOSED" && (
              <Button
                variant="outlined"
                className={styles.pbdAddChargeBtn}
                onClick={handleMiscCharge}
              >
                + Add Misc. Charge
              </Button>
            )}
          </div>

          {/* ---------- SUB SECTION: BILL CHARGES ---------- */}
          <div className={styles.pbdChargesSubsection}>
            <div className={styles.pbdChargesSubheader}>
              <span className={styles.pbdChargesSubheaderIcon}>📄</span>
              <span className={styles.pbdChargesSubheaderText}>
                Charges Applied on this Bill
              </span>
              <span className={styles.pbdChargesSubheaderCount}>
                {billCharges.length}
              </span>
            </div>

            <div className={styles.pbdChargesContainer}>
              {billCharges.length > 0 ? (
                billCharges.map((charge, i) => (
                  <div
                    className={styles.pbdChargeCard}
                    key={`bill-${charge.id}-${i}`}
                  >
                    {charge.chargeType === "misc_charge" && (
                      <div className={styles.pbdMiscBadge}>M</div>
                    )}

                    <div className={styles.pbdChargeInfo}>
                      <div className={styles.pbdChargeRow}>
                        <span className={styles.pbdChargeLabel}>ID:</span>
                        <span className={styles.pbdChargeValue}>
                          {charge.id}
                        </span>
                      </div>
                      <div className={styles.pbdChargeRow}>
                        <span className={styles.pbdChargeLabel}>Name:</span>
                        <span
                          className={styles.pbdChargeValue}
                          title={charge.name || charge.chargeType}
                        >
                          {charge.name ||
                            formatChargeTypeLabel(charge.chargeType)}
                        </span>
                      </div>
                      <div className={styles.pbdChargeRow}>
                        <span className={styles.pbdChargeLabel}>Type:</span>
                        <span
                          className={`${styles.pbdChargeValue} ${styles.pbdChargeValueBadge}`}
                        >
                          {formatChargeTypeLabel(charge.chargeType)}
                        </span>
                      </div>
                      <div className={styles.pbdChargeRow}>
                        <span className={styles.pbdChargeLabel}>Amount:</span>
                        <span
                          className={`${styles.pbdChargeValue} ${styles.pbdChargeValueAmount}`}
                        >
                          {charge.valueType === "amount_percentage" ||
                          charge.valueType === "percentage"
                            ? `${charge.amount}%`
                            : formatCurrency(charge.amount || 0)}
                        </span>
                      </div>
                    </div>

                    <IconButton
                      className={styles.pbdChargeViewBtn}
                      onClick={() => handleViewBillChargeClick(charge)}
                    >
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </div>
                ))
              ) : (
                <div className={styles.pbdNoCharges}>
                  No charges applied on this bill
                </div>
              )}
            </div>
          </div>

          <div className={styles.pbdChargesDivider} />

          {/* ---------- SUB SECTION: PARTNER CHARGES ---------- */}
          <div className={styles.pbdChargesSubsection}>
            <div className={styles.pbdChargesSubheader}>
              <span className={styles.pbdChargesSubheaderIcon}>⚙️</span>
              <span className={styles.pbdChargesSubheaderText}>
                Partner Charges Configuration
              </span>
              <span className={styles.pbdChargesSubheaderCount}>
                {partnerCharges.length}
              </span>
            </div>

            <div className={styles.pbdChargesContainer}>
              {partnerCharges.length > 0 ? (
                partnerCharges.map((charge, i) => (
                  <div
                    className={`${styles.pbdChargeCard} ${styles.pbdPartnerChargeCard}`}
                    key={`partner-${charge.id}-${i}`}
                  >
                    <div className={styles.pbdChargeInfo}>
                      <div className={styles.pbdChargeRow}>
                        <span className={styles.pbdChargeLabel}>ID:</span>
                        <span className={styles.pbdChargeValue}>
                          {charge.id}
                        </span>
                      </div>
                      <div className={styles.pbdChargeRow}>
                        <span className={styles.pbdChargeLabel}>Name:</span>
                        <span
                          className={styles.pbdChargeValue}
                          title={charge.name || "N/A"}
                        >
                          {charge.name || "N/A"}
                        </span>
                      </div>
                      <div className={styles.pbdChargeRow}>
                        <span className={styles.pbdChargeLabel}>Value:</span>
                        <span
                          className={`${styles.pbdChargeValue} ${styles.pbdChargeValueAmount}`}
                        >
                          {charge.valueType === "amount_percentage"
                            ? `${charge.value}%`
                            : formatCurrency(Number(charge.value) || 0)}
                        </span>
                      </div>
                    </div>

                    <IconButton
                      className={styles.pbdChargeViewBtn}
                      onClick={() => handleViewPartnerChargeClick(charge)}
                    >
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </div>
                ))
              ) : (
                <div className={styles.pbdNoCharges}>
                  No partner charges configured
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ============================================================
            CHARGE DETAILS DIALOG
            ============================================================ */}
        <Dialog
          open={openDialog}
          className={styles.pbdChargeDialog}
          PaperProps={{
            style: {
              borderRadius: "16px",
              padding: "8px",
              minWidth: "450px",
              maxWidth: "600px",
            },
          }}
        >
          <DialogTitle className={styles.pbdDialogTitle}>
            <div className={styles.pbdDialogTitleContent}>
              <img src={chargeicon} alt="Charge Icon" />
              <div>
                <Typography variant="h5" className={styles.pbdDialogTitleText}>
                  {activeChargeTab === "bill"
                    ? selectedCharge?.name ||
                      formatChargeTypeLabel(selectedCharge?.chargeType) ||
                      "Charge Details"
                    : selectedChargeDetails?.name ||
                      selectedCharge?.name ||
                      "Charge Details"}
                </Typography>
                <Typography
                  variant="subtitle2"
                  className={styles.pbdDialogSubtitle}
                >
                  {activeChargeTab === "bill"
                    ? "Bill Charge"
                    : "Partner Configuration Charge"}{" "}
                  · Charge ID:{" "}
                  {selectedChargeDetails?.id || selectedCharge?.id}
                </Typography>
              </div>
            </div>
          </DialogTitle>

          <DialogContent className={styles.pbdDialogContent}>
            <div className={styles.pbdChargeDetailsGrid}>
              {activeChargeTab === "bill" && selectedCharge ? (
                <>
                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Charge ID</span>
                    <span className={styles.pbdDetailValue}>
                      {selectedCharge.id}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Charge Name</span>
                    <span className={styles.pbdDetailValue}>
                      {selectedCharge.name || "N/A"}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Charge Type</span>
                    <span className={styles.pbdDetailValue}>
                      {formatChargeTypeLabel(selectedCharge.chargeType)}
                    </span>
                  </div>

                  <div
                    className={`${styles.pbdDetailItem} ${styles.pbdDetailFull}`}
                  >
                    <span className={styles.pbdDetailLabel}>Description</span>
                    <span className={styles.pbdDetailValue}>
                      {selectedCharge.description ||
                        "No description available"}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Value Type</span>
                    <span className={styles.pbdDetailValue}>
                      {formatValueType(selectedCharge.valueType)}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Amount</span>
                    <span
                      className={`${styles.pbdDetailValue} ${styles.pbdAmountValue}`}
                    >
                      {selectedCharge.valueType === "amount_percentage" ||
                      selectedCharge.valueType === "percentage"
                        ? `${selectedCharge.amount}%`
                        : formatCurrency(selectedCharge.amount || 0)}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>
                      Minimum Value
                    </span>
                    <span className={styles.pbdDetailValue}>
                      {selectedCharge.valueMin !== null &&
                      selectedCharge.valueMin !== undefined
                        ? selectedCharge.valueType === "amount_percentage"
                          ? `${selectedCharge.valueMin}%`
                          : formatCurrency(selectedCharge.valueMin)
                        : "Not Set"}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>
                      Maximum Value
                    </span>
                    <span className={styles.pbdDetailValue}>
                      {selectedCharge.valueMax !== null &&
                      selectedCharge.valueMax !== undefined
                        ? selectedCharge.valueType === "amount_percentage"
                          ? `${selectedCharge.valueMax}%`
                          : formatCurrency(selectedCharge.valueMax)
                        : "Not Set"}
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Charge ID</span>
                    <span className={styles.pbdDetailValue}>
                      {selectedChargeDetails?.id || selectedCharge?.id}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Charge Name</span>
                    <span className={styles.pbdDetailValue}>
                      {selectedChargeDetails?.name ||
                        selectedCharge?.name ||
                        "N/A"}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Charge Type</span>
                    <span className={styles.pbdDetailValue}>
                      {selectedChargeDetails?.chargeType ||
                        selectedCharge?.chargeType ||
                        "N/A"}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>
                      Deduction Type ID
                    </span>
                    <span className={styles.pbdDetailValue}>
                      {selectedChargeDetails?.deductionTypeId || "N/A"}
                    </span>
                  </div>

                  <div
                    className={`${styles.pbdDetailItem} ${styles.pbdDetailFull}`}
                  >
                    <span className={styles.pbdDetailLabel}>Description</span>
                    <span className={styles.pbdDetailValue}>
                      {selectedChargeDetails?.description ||
                        "No description available"}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>Value Type</span>
                    <span className={styles.pbdDetailValue}>
                      {selectedChargeDetails?.valueType || "N/A"}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>
                      Value Amount
                    </span>
                    <span
                      className={`${styles.pbdDetailValue} ${styles.pbdAmountValue}`}
                    >
                      {selectedChargeDetails?.value
                        ? selectedChargeDetails.valueType?.includes(
                            "percentage",
                          )
                          ? `${selectedChargeDetails.value}%`
                          : formatCurrency(
                              Number(selectedChargeDetails.value) || 0,
                            )
                        : formatCurrency(selectedCharge?.amount || 0)}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>
                      Minimum Value
                    </span>
                    <span className={styles.pbdDetailValue}>
                      {selectedChargeDetails?.valueMin
                        ? selectedChargeDetails.valueType?.includes(
                            "percentage",
                          )
                          ? `${selectedChargeDetails.valueMin}%`
                          : formatCurrency(
                              Number(selectedChargeDetails.valueMin) || 0,
                            )
                        : "Not Set"}
                    </span>
                  </div>

                  <div className={styles.pbdDetailItem}>
                    <span className={styles.pbdDetailLabel}>
                      Maximum Value
                    </span>
                    <span className={styles.pbdDetailValue}>
                      {selectedChargeDetails?.valueMax
                        ? selectedChargeDetails.valueType?.includes(
                            "percentage",
                          )
                          ? `${selectedChargeDetails.valueMax}%`
                          : formatCurrency(
                              Number(selectedChargeDetails.valueMax) || 0,
                            )
                        : "Not Set"}
                    </span>
                  </div>
                </>
              )}
            </div>
          </DialogContent>

          <DialogActions className={styles.pbdDialogActions}>
            <Button
              onClick={handleCloseDialog}
              variant="contained"
              className={styles.pbdDialogCloseBtn}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* ============================================================
            DEDUCTION DETAILS DIALOG
            ============================================================ */}
        <Dialog
          open={showDeductionDetails}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              maxHeight: "90vh",
              overflow: "hidden",
              borderRadius: "16px",
            },
          }}
        >
          <div className={styles.pbdDeductionHeader}>
            <DialogTitle className={styles.pbdDeductionTitle}>
              {formatChargeSummaryDate()}
              {chargeSummery?.payoutId
                ? ` (Payout ID ${chargeSummery.payoutId})`
                : ""}
            </DialogTitle>
            <IconButton
              onClick={() => setShowDeductionDetails(false)}
              className={styles.pbdDeductionClose}
            >
              <img src={cancel} alt="Close" style={{ width: 24, height: 24 }} />
            </IconButton>
          </div>

          <DialogContent className={styles.pbdDeductionContent}>
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div className={styles.pbdDeductionWrapper}>
                {/* Partner Info */}
                <div className={styles.pbdPartnerInfo}>
                  <div className={styles.pbdPartnerInfoRow}>
                    <div>
                      <span className={styles.pbdInfoLabel}>
                        Partner Name
                      </span>
                      <span className={styles.pbdInfoValue}>
                        {chargeSummery?.name || "N/A"} (
                        {chargeSummery?.type || "N/A"})
                      </span>
                      <br />
                      <span className={styles.pbdInfoLabel}>Cohort ID</span>
                      <span className={styles.pbdInfoValue}>
                        {chargeSummery?.cohortId || "N/A"}
                      </span>
                    </div>
                    <div>
                      <span className={styles.pbdInfoLabel}>Partner Id</span>
                      <span className={styles.pbdInfoValue}>
                        {chargeSummery?.franchiseeId || "N/A"}
                      </span>
                      <br />
                      <span className={styles.pbdInfoLabel}>Total VM</span>
                      <span className={styles.pbdInfoValue}>
                        {chargeSummery?.vmCount || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Transactional Charges Table */}
                <h4 className={styles.pbdTableTitle}>
                  Charge Summary (Transactional)
                </h4>
                <TableContainer className={styles.pbdTableContainer}>
                  <Table size="small">
                    <TableHead>
                      <TableRow className={styles.pbdTableHeaderRow}>
                        <TableCell
                          className={styles.pbdTableHeaderCell}
                          style={{ width: "20%" }}
                        >
                          Deduction ID
                        </TableCell>
                        <TableCell
                          className={styles.pbdTableHeaderCell}
                          style={{ width: "50%" }}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          className={styles.pbdTableHeaderCell}
                          align="right"
                          style={{ width: "30%" }}
                        >
                          Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {chargeSummery?.transactionalCharges?.map((charge) => (
                        <TableRow
                          key={`transactional-${charge.id}`}
                          className={styles.pbdTableBodyRow}
                        >
                          <TableCell>{charge.id}</TableCell>
                          <TableCell>
                            {charge.chargeType === "raas_fee"
                              ? "RAAS Fee(%)"
                              : charge.chargeType === "ps_fee"
                                ? "PS Fee(%)"
                                : charge.chargeType}
                          </TableCell>
                          <TableCell align="right">
                            {formatCurrency(charge.amount)}
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow className={styles.pbdTableTotalRow}>
                        <TableCell colSpan={2}>% Charge Total</TableCell>
                        <TableCell align="right">
                          {formatCurrency(totalTransactionalAmount || 0)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Fixed Charges Table */}
                <h4 className={styles.pbdTableTitle}>
                  Charge Summary (Fixed)
                </h4>
                <TableContainer className={styles.pbdTableContainer}>
                  <Table size="small">
                    <TableHead>
                      <TableRow className={styles.pbdTableHeaderRow}>
                        <TableCell
                          className={styles.pbdTableHeaderCell}
                          style={{ width: "20%" }}
                        >
                          Deduction ID
                        </TableCell>
                        <TableCell
                          className={styles.pbdTableHeaderCell}
                          style={{ width: "50%" }}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          className={styles.pbdTableHeaderCell}
                          align="right"
                          style={{ width: "30%" }}
                        >
                          Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {chargeSummery?.fixedCharges?.map((charge) => (
                        <TableRow
                          key={`fixed-${charge.id}`}
                          className={styles.pbdTableBodyRow}
                        >
                          <TableCell>{charge.id}</TableCell>
                          <TableCell>
                            {charge.chargeType === "saas_ik"
                              ? "SAAS IK"
                              : charge.chargeType === "rental_ik"
                                ? "Rental IK"
                                : charge.chargeType === "misc_charge"
                                  ? "Miscellaneous"
                                  : charge.chargeType}
                          </TableCell>
                          <TableCell align="right">
                            {formatCurrency(charge.amount)}
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow className={styles.pbdTableTotalRow}>
                        <TableCell colSpan={2}>Fix Charge Total</TableCell>
                        <TableCell align="right">
                          {formatCurrency(totalFixedAmount || 0)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Total Deduction */}
                <div className={styles.pbdTotalDeduction}>
                  Total Deduction (Transactional + Fixed) ={" "}
                  {formatCurrency(
                    (chargeSummery?.totalTransactionalDeductions || 0) +
                      (chargeSummery?.totalFixedDeductions || 0),
                  )}
                </div>

                {/* Net Deduction - Only when negative */}
                {isNetPayableNegative && (
                  <div className={styles.pbdNetDeduction}>
                    Net Deduction (Total Deduction + Net Payout) ={" "}
                    {formatCurrency(netDeduction)}
                    <span className={styles.pbdNetPayoutInfo}>
                      (Net Payout: {formatCurrency(selectedDayNetPayable)})
                    </span>
                  </div>
                )}
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* ============================================================
            SUMMARY SECTION
            ============================================================ */}
        <div className={styles.pbdSummarySection}>
          <div className={styles.pbdSummaryHeader}>
            <h4 className={styles.pbdSummaryTitle}>
              <span className={styles.pbdIcon}>📅</span> Bill Summary -{" "}
              <span className={styles.pbdDateRange}>
                {payoutBillData?.startDate || getDisplayStartDate()}
              </span>
              <span className={styles.pbdDateSeparator}>to</span>
              <span className={styles.pbdDateRange}>
                {payoutBillData?.endDate || getDisplayEndDate()}
              </span>
              <span
                className={`${styles.pbdStatusBadge} ${
                  styles[
                    `pbdStatus${billData.status?.charAt(0)}${billData.status
                      ?.slice(1)
                      .toLowerCase()}`
                  ] || ""
                }`}
              >
                {billData.status}
              </span>
            </h4>
            {hasBillId && (
              <span className={styles.pbdPastBillsLink} onClick={handlePostBill}>
                View Past Bills →
              </span>
            )}
          </div>

          <div className={styles.pbdSummaryCards}>
            <div className={styles.pbdSummaryCard}>
              <div className={styles.pbdCardLabel}>Total Gross Sale</div>
              <strong className={styles.pbdCardValue}>
                {formatCurrency(payoutBillData?.totalGrossSale || 0)}
              </strong>
            </div>
            <div className={styles.pbdSummaryCard}>
              <div className={styles.pbdCardLabel}>Total Fix Deduction</div>
              <strong className={styles.pbdCardValue}>
                {formatCurrency(payoutBillData?.totalFixedDeductions || 0)}
              </strong>
            </div>
            <div className={styles.pbdSummaryCard}>
              <div className={styles.pbdCardLabel}>
                Total Transactional Deduction
              </div>
              <strong className={styles.pbdCardValue}>
                {formatCurrency(
                  payoutBillData?.totalTransactionalDeductions || 0,
                )}
              </strong>
            </div>
            <div className={styles.pbdSummaryCard}>
              <div className={styles.pbdCardLabel}>Net Payout</div>
              <strong
                className={`${styles.pbdCardValue} ${
                  (payoutBillData?.totalNetPayable || 0) < 0
                    ? styles.pbdNegative
                    : styles.pbdPositive
                }`}
              >
                {formatCurrency(payoutBillData?.totalNetPayable || 0)}
              </strong>
            </div>
          </div>
        </div>

        {/* ============================================================
            DAY-WISE TABLE
            ============================================================ */}
        <div className={styles.pbdTableSection}>
          <h4 className={styles.pbdTableSectionTitle}>
            <span className={styles.pbdIcon}>📊</span> Day Wise Payout Details
          </h4>
          <div className={styles.pbdTableWrapper}>
            <table className={styles.pbdPayoutTable}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Settlement ID</th>
                  <th>Total Gross Sale</th>
                  <th>Net Payout</th>
                  <th>Total Deduction</th>
                </tr>
              </thead>
              <tbody>
                {payoutBillData?.payouts?.map((day, i) => (
                  <tr key={i}>
                    <td>{day.date}</td>
                    <td>{day.payoutId}</td>
                    <td>{formatCurrency(Number(day.revenueToday) || 0)}</td>
                    <td
                      className={
                        day.netPayable < 0
                          ? styles.pbdNegativeValue
                          : styles.pbdPositiveValue
                      }
                    >
                      {formatCurrency(day.netPayable || 0)}
                    </td>
                    <td>
                      <span
                        className={styles.pbdDeductionLink}
                        onClick={() => {
                          handleDeductionClick(
                            day.payoutId,
                            day.netPayable < 0
                              ? day.revenueToday
                              : day.totalDeductions,
                            i,
                          );
                        }}
                      >
                        {formatCurrency(
                          day.netPayable < 0
                            ? day.revenueToday
                            : day.totalDeductions,
                        )}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerBillDetailsComponent;